// Editor addin that renders the diff leaf marks as classes (RES-561 compare).
//
// Same install/leafModifier shape as the package's inlineStyle addin
// (@threeskye/editor-component-slate engine/inlineStyle.js): the Leaf component
// calls every addin's leafModifier(props, classes) and joins the pushed classes.
// Styling lives in ComparePage.scss (.diff-added / .diff-removed, with a
// .hide-changes ancestor reset for the eye toggle); .diff-hunk-<id> carries the
// hunk identity for change navigation and the hover-author stretch.

export default function diffMarksAddin() {
	return {
		install: (editor) => {
			return {
				leafModifier: (props, classes) => {
					if (props.leaf.diffAdded)
						classes.push('diff-added');
					if (props.leaf.diffRemoved)
						classes.push('diff-removed');
					if (props.leaf.diffHunk !== undefined && props.leaf.diffHunk !== null)
						classes.push('diff-hunk-' + props.leaf.diffHunk);
				},
				editor,
			};
		},
	};
}
